import chunk from 'lodash/chunk'

import { channelsInstance, instance } from '@/api/instances'

const searchStaffForChannel = async (store, { query, signal }) => {
  try {
    const staffList = await channelsInstance.get('staff', {
      signal,
      params: { namePrefix: query, canBeAddedToChannel: 'true' }
    })

    return staffList
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'staff/searchStaffForChannel' },
      { root: true }
    )
  }
}

const searchStaff = async (store, { query, options }) => {
  return await instance.get('staff', {
    ...options,
    params: { query }
  })
}

const getStaffs = async (store, { staffIds }) => {
  try {
    const ids = staffIds.filter(
      id => Boolean(id) && store.state.all[id] === undefined
    )

    if (ids.length !== 0) {
      const chunks = chunk(ids, 20)

      for (const page of chunks) {
        const staffs = await store.dispatch('getStaffsById', page)
        store.commit('setAll', staffs)
      }
    }
  } catch (error) {
    store.commit(
      'errors/setError',
      'Não conseguimos pegar os dados de staff.',
      {
        root: true
      }
    )
  }
}

const getStaffsById = async (_, params) => {
  if (Array.isArray(params)) {
    const ids = params.join(',')
    return await instance.get(`staff?ids=${ids}`)
  }
  return await instance.get(`staff/${params}`)
}

export default {
  searchStaffForChannel,
  getStaffs,
  searchStaff,
  getStaffsById
}
